// extracted by mini-css-extract-plugin
export default {"pop-up-text":"TextWithIconForPopUp_pop-up-text__8iE-0","pop-up-text__icon":"TextWithIconForPopUp_pop-up-text__icon__vRXDq"};